// (Copyright) Confluent, Inc.

import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { VisuallyHidden } from '@reach/visually-hidden';

import { useCTranslation } from '../../../utils/Translators';

// Note: these styles are duplicated in cloud/index.html for the root-loader element.
// When making changes here, please also adapt changes to that file.
const stretchDelay = keyframes`
  0%,
  40%,
  100% {
    transform: scaleY(.4);
  }

  20% {
    transform: scaleY(1);
  }
`;

/* eslint-disable rulesdir/no-css-var-colors */
const Root = styled.div`
  margin: auto;
  width: 50px;
  height: 20px;
  text-align: center;
  font-size: 10px;

  > div {
    background-color: var(--PRIMARY_LIGHT);
    height: 100%;
    width: 3px;
    margin: 0 1px;
    display: inline-block;
    animation: ${stretchDelay} 1.2s infinite ease-in-out;
  }

  > div:nth-child(2) {
    animation-delay: -1.1s;
  }

  > div:nth-child(3) {
    animation-delay: -1s;
  }

  > div:nth-child(4) {
    animation-delay: -0.9s;
  }

  > div:nth-child(5) {
    animation-delay: -0.8s;
  }
`;
/* eslint-enable rulesdir/no-css-var-colors */

export const InlineLoader = ({ className }: { className?: string | null | undefined }) => {
  const [t] = useCTranslation();
  return (
    <Root className={className} data-testid="inline-loader">
      <VisuallyHidden>{t('InlineLoader.AccessibilityLabel')}</VisuallyHidden>
      <div />
      <div />
      <div />
      <div />
      <div />
    </Root>
  );
};

export default InlineLoader;
